module.exports = __webpack_public_path__ + "static/contact-ccc3b2aebe861d398528e4cc387283a2.jpg";